/*
 * Diwali Oil Offer
 * - Product cards: size selection, quantity, AJAX add to cart
 * - Live "litres of qualifying oil (e.g. groundnut) in cart" tracker for the free sesame oil gift
 * - Keeps a cart attribute (e.g. "Diwali Free Gift: 1 L Sesame Oil") in sync,
 *   so the gift shows on the order in Shopify admin.
 * Config: window.DiwaliOilOffer (snippets/diwali-offer-config.liquid)
 */
(function () {
  'use strict';
  if (window.__dwoLoaded) return;
  window.__dwoLoaded = true;

  var C = window.DiwaliOilOffer = window.DiwaliOilOffer || {};
  var ROOT = (C.root || '/').replace(/\/?$/, '/');
  var SYNC_FLAG = 'dwo_sync=1';
  var TIERS = (C.tiers || []).slice().sort(function (a, b) { return b.minLitres - a.minLitres; });
  var TYPES = (C.productTypes || []).map(function (t) { return String(t).toLowerCase(); });
  var nativeFetch = window.fetch.bind(window);

  /* ---------------- helpers ---------------- */

  function offerActive() {
    if (!C.endDate) return true;
    var end = new Date(C.endDate + 'T23:59:59');
    return isNaN(end.getTime()) || new Date() <= end;
  }

  // "500ml" -> 0.5, "1l" -> 1, "1000ml" -> 1, "2 Ltr" -> 2
  function parseLitres(text) {
    if (!text) return 0;
    var m = String(text).toLowerCase().replace(/,/g, '')
      .match(/(\d+(?:\.\d+)?)\s*(ml|l|lt|ltr|ltrs|litre|litres|liter|liters)\b/);
    if (!m) return 0;
    var n = parseFloat(m[1]);
    return m[2] === 'ml' ? n / 1000 : n;
  }

  function fmtLitres(l) {
    l = Math.round(l * 1000) / 1000;
    if (l > 0 && l < 1) return Math.round(l * 1000) + ' ml';
    return (Math.round(l * 100) / 100) + ' L';
  }

  function formatMoney(cents) {
    var fmt = C.moneyFormat || 'Rs. {{amount}}';
    function fmtNum(value, decimals, thousands, decimal) {
      var parts = (value / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmtNum(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return fmtNum(cents, 0, ' ', '.');
        case 'amount_with_space_separator': return fmtNum(cents, 2, ' ', ',');
        default: return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var HANDLES = (C.qualifyingHandles || []).map(function (h) { return String(h).toLowerCase(); });
  var KEYWORDS = (C.qualifyingKeywords || []).map(function (k) { return String(k).toLowerCase(); });
  var LABEL = C.offerLabel || 'oil';

  // Does this product count towards the offer? p = { handle, title, productType }
  function qualifies(p) {
    var type = String(p.productType || '').toLowerCase();
    if (TYPES.length && TYPES.indexOf(type) === -1) return false;
    if (!HANDLES.length && !KEYWORDS.length) return true;
    var handle = String(p.handle || '').toLowerCase();
    var title = String(p.title || '').toLowerCase();
    if (HANDLES.indexOf(handle) !== -1) return true;
    return KEYWORDS.some(function (k) { return title.indexOf(k) !== -1 || handle.indexOf(k) !== -1; });
  }

  function itemLitres(item) {
    var l = parseLitres(item.variant_title);
    if (!l && item.options_with_values) {
      item.options_with_values.forEach(function (o) { l = l || parseLitres(o.value); });
    }
    return l || parseLitres(item.title);
  }

  /* ---------------- offer logic ---------------- */

  function computeOffer(cart) {
    var litres = 0;
    (cart.items || []).forEach(function (item) {
      var p = { handle: item.handle, title: item.product_title || item.title, productType: item.product_type };
      if (qualifies(p)) litres += itemLitres(item) * item.quantity;
    });
    litres = Math.round(litres * 1000) / 1000;

    var unlocked = null, next = null;
    for (var i = 0; i < TIERS.length; i++) {
      if (litres >= TIERS[i].minLitres) { unlocked = TIERS[i]; break; }
      next = TIERS[i]; // tiers are sorted high -> low, so last one seen is the nearest above
    }
    return {
      litres: litres,
      unlocked: unlocked,
      next: next,
      remaining: next ? Math.max(0, next.minLitres - litres) : 0
    };
  }

  function offerMessage(o) {
    if (o.unlocked && !o.next) {
      return '🎉 Congratulations! You have unlocked <strong>FREE ' + escapeHtml(o.unlocked.gift) +
        '</strong>. It will be packed with your order.';
    }
    if (o.unlocked && o.next) {
      return '🎉 You have unlocked <strong>FREE ' + escapeHtml(o.unlocked.gift) + '</strong>! Add <strong>' +
        fmtLitres(o.remaining) + '</strong> more ' + escapeHtml(LABEL) + ' to upgrade to <strong>FREE ' + escapeHtml(o.next.gift) + '</strong>.';
    }
    if (o.next && o.litres > 0) {
      return '🪔 You have ' + fmtLitres(o.litres) + ' of ' + escapeHtml(LABEL) + ' in your cart. Add <strong>' + fmtLitres(o.remaining) +
        '</strong> more ' + escapeHtml(LABEL) + ' to get <strong>FREE ' + escapeHtml(o.next.gift) + '</strong>!';
    }
    if (o.next) {
      return '🪔 Diwali offer: buy ' + fmtLitres(o.next.minLitres) + ' or more of <strong>' + escapeHtml(LABEL) +
        '</strong> and get <strong>FREE ' + escapeHtml(o.next.gift) + '</strong>!';
    }
    return '';
  }

  function renderProgress(o) {
    var max = TIERS.length ? TIERS[0].minLitres : 1;
    var pct = Math.min(100, (o.litres / max) * 100);

    document.querySelectorAll('[data-dwo-progress]').forEach(function (el) {
      if (!offerActive()) { el.hidden = true; return; }
      if (!el.__dwoBuilt) {
        var marks = TIERS.map(function (t) {
          var left = (t.minLitres / max) * 100;
          return '<span class="dwo-mark' + (left >= 85 ? ' is-end' : '') + '" data-min="' + t.minLitres + '" style="left:' + left + '%">' +
            '<span class="dwo-mark__dot"></span>' +
            '<span class="dwo-mark__label">' + fmtLitres(t.minLitres) + '<br><small>' + escapeHtml(t.gift) + ' free</small></span>' +
            '</span>';
        }).join('');
        el.innerHTML =
          '<p class="dwo-progress__msg" data-dwo-msg></p>' +
          '<div class="dwo-bar" role="progressbar" aria-valuemin="0" aria-valuemax="' + max + '">' +
          '<span class="dwo-bar__fill" data-dwo-fill></span>' + marks + '</div>';
        el.__dwoBuilt = true;
      }
      el.querySelector('[data-dwo-msg]').innerHTML = offerMessage(o);
      el.querySelector('[data-dwo-fill]').style.width = pct + '%';
      el.querySelector('.dwo-bar').setAttribute('aria-valuenow', o.litres);
      el.querySelectorAll('.dwo-mark').forEach(function (m) {
        m.classList.toggle('is-reached', o.litres >= parseFloat(m.getAttribute('data-min')));
      });
      el.classList.toggle('is-unlocked', !!o.unlocked);
    });

    var sticky = document.querySelector('[data-dwo-sticky]');
    if (sticky) {
      sticky.hidden = !offerActive();
      sticky.querySelector('[data-dwo-sticky-msg]').innerHTML = offerMessage(o);
      sticky.classList.toggle('is-unlocked', !!o.unlocked);
    }
  }

  function updateCartCount(cart) {
    document.querySelectorAll('.js-cart-count, [data-cart-count], .cart-count-bubble span, .cart-count').forEach(function (el) {
      if (el.children.length === 0) el.textContent = cart.item_count;
    });
  }

  // Rebuild the theme's header mini cart (product list + total), like the theme's own add-to-cart does
  function refreshThemeMiniCart() {
    try {
      var mc = window.theme && window.theme.miniCart;
      if (mc) {
        if (typeof mc.updateElements === 'function') mc.updateElements();
        if (typeof mc.generateCart === 'function') mc.generateCart();
      }
    } catch (e) { console.warn('[Diwali offer] mini cart refresh', e); }
  }

  // Keep hidden attribute inputs in cart forms in sync, so submitting the
  // cart form (Update / Checkout) carries the right gift.
  function syncCartForms(value) {
    var name = 'attributes[' + C.attributeName + ']';
    document.querySelectorAll('form[action$="/cart"], form[action*="/cart?"]').forEach(function (form) {
      var input = form.querySelector('input[data-dwo-attr]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute('data-dwo-attr', '');
        form.appendChild(input);
      }
      input.value = value;
    });
  }

  function syncAttribute(cart, o) {
    if (!C.attributeName) return Promise.resolve(cart);
    var desired = offerActive() && o.unlocked ? o.unlocked.gift : '';
    var current = (cart.attributes && cart.attributes[C.attributeName]) || '';
    syncCartForms(desired);
    if (desired === current) return Promise.resolve(cart);
    var attrs = {};
    attrs[C.attributeName] = desired; // empty string removes the attribute
    return nativeFetch(ROOT + 'cart/update.js?' + SYNC_FLAG, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { return r.json(); }).catch(function () { return cart; });
  }

  function getCart() {
    return nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  var lastGiftMin; // undefined until the first cart load, so a page load never celebrates
  function refresh() {
    return getCart().then(function (cart) {
      var o = computeOffer(cart);
      var giftMin = o.unlocked ? o.unlocked.minLitres : 0;
      if (lastGiftMin !== undefined && giftMin > lastGiftMin && offerActive()) celebrate();
      lastGiftMin = giftMin;
      renderProgress(o);
      updateCartCount(cart);
      return syncAttribute(cart, o).then(function () { return { cart: cart, offer: o }; });
    }).catch(function (e) { console.warn('[Diwali offer]', e); });
  }

  var refreshTimer;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 300);
  }

  /* ---- watch cart changes made by the theme (mini cart, cart page AJAX) ---- */

  function isCartMutation(url) {
    url = String(url || '');
    return /\/cart\/(add|change|update|clear)(\.js)?/.test(url) && url.indexOf(SYNC_FLAG) === -1;
  }

  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : input && input.url;
    var p = nativeFetch.apply(window, arguments);
    if (isCartMutation(url)) p.then(scheduleRefresh, function () {});
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__dwoUrl = url;
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this.__dwoUrl)) this.addEventListener('loadend', scheduleRefresh);
    return xhrSend.apply(this, arguments);
  };

  /* ---------------- fireworks (crackers) ---------------- */

  var FX_COLORS = ['#ffd54a', '#f7b733', '#ff7b00', '#ff3d3d', '#ff4fa3', '#7cff6b', '#4fd2ff', '#ffffff'];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function fxEnabled() {
    return !reduceMotion && offerActive() && !!document.querySelector('[data-dwo-fx]');
  }

  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  // A canvas that draws rockets + bursts. `auto` keeps launching rockets on its own.
  function Fireworks(canvas, opts) {
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.opts = opts || {};
    this.rockets = [];
    this.sparks = [];
    this.running = false;
    this.visible = true;
    this.nextLaunch = 0;
    this.resize = this.resize.bind(this);
    this.frame = this.frame.bind(this);
    this.resize();
    window.addEventListener('resize', this.resize);
  }
  Fireworks.prototype.resize = function () {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var r = this.canvas.getBoundingClientRect();
    this.w = r.width; this.h = r.height;
    this.canvas.width = Math.max(1, r.width * dpr);
    this.canvas.height = Math.max(1, r.height * dpr);
    this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  Fireworks.prototype.launch = function (x, targetY) {
    x = x == null ? rand(this.w * 0.1, this.w * 0.9) : x;
    targetY = targetY == null ? rand(this.h * 0.12, this.h * 0.45) : targetY;
    this.rockets.push({ x: x, y: this.h + 4, vy: -Math.sqrt(2 * 0.12 * (this.h - targetY)), color: pick(FX_COLORS), trail: [] });
    this.start();
  };
  Fireworks.prototype.burst = function (x, y, scale) {
    scale = scale || 1;
    var count = Math.round(rand(46, 70) * scale);
    var color = pick(FX_COLORS), color2 = pick(FX_COLORS);
    var ring = Math.random() < 0.3;
    for (var i = 0; i < count; i++) {
      var a = (Math.PI * 2 * i) / count + rand(-0.05, 0.05);
      var speed = (ring ? 3.4 : rand(1, 4.2)) * scale;
      this.sparks.push({
        x: x, y: y, px: x, py: y,
        vx: Math.cos(a) * speed, vy: Math.sin(a) * speed,
        life: 1, decay: rand(0.009, 0.016),
        color: Math.random() < 0.7 ? color : color2,
        size: rand(2, 3.4) * Math.max(0.8, scale * 0.9),
        twinkle: Math.random() < 0.35
      });
    }
    this.start();
  };
  Fireworks.prototype.start = function () {
    if (this.running || !this.visible) return;
    this.running = true;
    this.last = performance.now();
    requestAnimationFrame(this.frame);
  };
  Fireworks.prototype.frame = function (now) {
    var ctx = this.ctx, dt = Math.min(2.5, (now - this.last) / 16.67);
    this.last = now;

    // fade previous frame -> soft trails
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,0.22)';
    ctx.fillRect(0, 0, this.w, this.h);
    ctx.globalCompositeOperation = 'lighter';

    if (this.opts.auto && now > this.nextLaunch) {
      this.launch();
      if (Math.random() < 0.3) this.launch();
      this.nextLaunch = now + rand(650, 1500);
    }

    for (var i = this.rockets.length - 1; i >= 0; i--) {
      var r = this.rockets[i];
      r.y += r.vy * dt; r.vy += 0.12 * dt; r.x += rand(-0.4, 0.4);
      ctx.fillStyle = '#fff3c4';
      ctx.beginPath(); ctx.arc(r.x, r.y, 2, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = 'rgba(255,180,60,0.6)';
      ctx.beginPath(); ctx.arc(r.x + rand(-1, 1), r.y + 6, 1.4, 0, Math.PI * 2); ctx.fill();
      if (r.vy >= -0.5) { this.burst(r.x, r.y, this.opts.scale); this.rockets.splice(i, 1); }
    }

    for (var j = this.sparks.length - 1; j >= 0; j--) {
      var s = this.sparks[j];
      s.px = s.x; s.py = s.y;
      s.vx *= Math.pow(0.97, dt); s.vy = s.vy * Math.pow(0.97, dt) + 0.045 * dt;
      s.x += s.vx * dt; s.y += s.vy * dt;
      s.life -= s.decay * dt;
      if (s.life <= 0) { this.sparks.splice(j, 1); continue; }
      ctx.globalAlpha = s.twinkle ? s.life * (Math.random() < 0.5 ? 1 : 0.3) : s.life;
      ctx.strokeStyle = s.color;
      ctx.lineWidth = s.size;
      ctx.beginPath(); ctx.moveTo(s.px, s.py); ctx.lineTo(s.x, s.y); ctx.stroke();
    }
    ctx.globalAlpha = 1;

    var busy = this.opts.auto || this.rockets.length || this.sparks.length;
    if (busy && this.visible) {
      requestAnimationFrame(this.frame);
    } else {
      this.running = false;
      ctx.clearRect(0, 0, this.w, this.h);
      if (this.opts.onIdle) this.opts.onIdle();
    }
  };
  Fireworks.prototype.setVisible = function (v) {
    this.visible = v;
    if (v) this.start();
  };

  // Continuous crackers behind the banner
  function initHeroFireworks() {
    if (!fxEnabled()) return;
    document.querySelectorAll('[data-dwo-fx-canvas]').forEach(function (canvas) {
      if (canvas.__dwoFx) return;
      var fx = canvas.__dwoFx = new Fireworks(canvas, { auto: true, scale: canvas.getBoundingClientRect().width < 600 ? 0.75 : 1 });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          fx.setVisible(entries[0].isIntersecting && !document.hidden);
        }).observe(canvas);
      }
      document.addEventListener('visibilitychange', function () { fx.setVisible(!document.hidden); });
      fx.start();
    });
  }

  // Full-screen overlay for celebrations
  var overlayFx;
  function getOverlay() {
    if (overlayFx) return overlayFx;
    var canvas = document.createElement('canvas');
    canvas.className = 'dwo-fx-overlay';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    overlayFx = new Fireworks(canvas, {
      scale: window.innerWidth < 600 ? 0.8 : 1.15,
      onIdle: function () { canvas.style.opacity = '0'; }
    });
    canvas.__dwoFx = overlayFx;
    return overlayFx;
  }

  // Small cracker pop from an element (e.g. the Add to cart button)
  function popAt(el) {
    if (!fxEnabled() || !el) return;
    var fx = getOverlay();
    fx.canvas.style.opacity = '1';
    fx.resize();
    var r = el.getBoundingClientRect();
    fx.burst(r.left + r.width / 2, r.top + r.height / 2, 0.55);
  }

  // Big show when a free gift is unlocked
  function celebrate() {
    if (!fxEnabled()) return;
    var fx = getOverlay();
    fx.canvas.style.opacity = '1';
    fx.resize();
    for (var i = 0; i < 9; i++) {
      setTimeout(function () { fx.launch(); }, i * 260);
    }
  }

  /* ---------------- toast ---------------- */

  var toast;
  function showToast(html) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'dwo-toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    toast.innerHTML =
      '<button type="button" class="dwo-toast__close" aria-label="Close">&times;</button>' + html +
      '<div class="dwo-toast__actions">' +
      '<a class="dwo-btn dwo-btn--small" href="' + (C.cartUrl || '/cart') + '">View cart</a>' +
      '<a class="dwo-btn dwo-btn--small dwo-btn--ghost" href="' + (C.checkoutUrl || '/checkout') + '">Checkout</a>' +
      '</div>';
    toast.querySelector('.dwo-toast__close').onclick = function () { toast.classList.remove('is-open'); };
    toast.classList.add('is-open');
    clearTimeout(toast.__t);
    toast.__t = setTimeout(function () { toast.classList.remove('is-open'); }, 7000);
  }

  /* ---------------- product cards ---------------- */

  function initCard(card) {
    var data;
    try { data = JSON.parse(card.querySelector('[data-dwo-json]').textContent); } catch (e) { return; }

    var form = card.querySelector('[data-dwo-form]');
    var idInput = card.querySelector('[data-dwo-variant-id]');
    var qtyInput = card.querySelector('[data-dwo-qty]');
    var addBtn = card.querySelector('[data-dwo-add]');
    var addLabel = card.querySelector('[data-dwo-add-label]');
    var priceEl = card.querySelector('[data-dwo-price]');
    var compareEl = card.querySelector('[data-dwo-compare]');
    var saleBadge = card.querySelector('[data-dwo-sale-badge]');
    var img = card.querySelector('[data-dwo-image]');
    var contribEl = card.querySelector('[data-dwo-contrib]');
    var errorEl = card.querySelector('[data-dwo-error]');
    var fieldsets = card.querySelectorAll('[data-dwo-option]');
    var oil = qualifies({ handle: data.handle, title: data.title, productType: data.productType });

    // Tag the products that count towards the offer
    card.classList.toggle('dwo-card--offer', oil && offerActive());
    if (oil && offerActive() && C.offerBadge && !card.querySelector('.dwo-card__offer-tag')) {
      var tag = document.createElement('span');
      tag.className = 'dwo-card__offer-tag';
      tag.textContent = C.offerBadge;
      var media = card.querySelector('.dwo-card__media');
      if (media) media.appendChild(tag);
    }

    var variant = data.variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || data.variants[0];
    var selected = variant.options.slice();

    function findVariant() {
      return data.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      })[0];
    }

    function qty() {
      var n = parseInt(qtyInput.value, 10);
      return isNaN(n) || n < 1 ? 1 : Math.min(n, 99);
    }

    function updateContrib() {
      if (!contribEl) return;
      var l = variant ? parseLitres(variant.title) : 0;
      if (!oil || !l || !offerActive()) { contribEl.textContent = ''; return; }
      var total = l * qty();
      var tier = TIERS.filter(function (t) { return total >= t.minLitres; })[0];
      contribEl.innerHTML = tier
        ? '🎁 ' + fmtLitres(total) + ' – this alone unlocks <strong>FREE ' + escapeHtml(tier.gift) + '</strong>!'
        : 'Adds ' + fmtLitres(total) + ' of ' + escapeHtml(LABEL) + ' towards your free Sesame Oil';
    }

    function update() {
      variant = findVariant();

      // option pills: active state + mark combinations that are sold out / don't exist
      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-dwo-option'), 10);
        fs.querySelectorAll('[data-dwo-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-dwo-value');
          var active = val === selected[idx];
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          var probe = selected.slice(); probe[idx] = val;
          var match = data.variants.filter(function (v) {
            return v.options.every(function (opt, i) { return opt === probe[i]; });
          })[0];
          btn.classList.toggle('is-unavailable', !match || !match.available);
        });
      });

      errorEl.hidden = true;
      if (!variant) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        updateContrib();
        return;
      }

      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price > variant.price;
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price);
      if (saleBadge) saleBadge.hidden = !onSale;

      if (img && variant.image) {
        img.removeAttribute('srcset');
        img.src = variant.image;
      }

      addBtn.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      updateContrib();
    }

    card.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-dwo-value]');
      if (pill) {
        var fs = pill.closest('[data-dwo-option]');
        selected[parseInt(fs.getAttribute('data-dwo-option'), 10)] = pill.getAttribute('data-dwo-value');
        update();
        return;
      }
      if (e.target.closest('[data-dwo-minus]')) { qtyInput.value = Math.max(1, qty() - 1); updateContrib(); }
      if (e.target.closest('[data-dwo-plus]')) { qtyInput.value = Math.min(99, qty() + 1); updateContrib(); }
    });

    qtyInput.addEventListener('input', updateContrib);
    qtyInput.addEventListener('change', function () { qtyInput.value = qty(); updateContrib(); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!variant || !variant.available) return;
      var quantity = qty();
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      addLabel.textContent = 'Adding…';
      errorEl.hidden = true;

      nativeFetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: quantity }] })
      })
        .then(function (r) {
          return r.json().then(function (json) {
            if (!r.ok) throw new Error(json.description || json.message || 'Could not add to cart');
            return json;
          });
        })
        .then(function () { return refresh(); })
        .then(function (res) {
          refreshThemeMiniCart();
          // Combo pages (no litre tracker): the gift is part of the product, so every add is a celebration
          var comboMode = !!card.closest('[data-dwo-celebrate-add]');
          if (comboMode) celebrate(); else popAt(addBtn);
          addLabel.textContent = 'Added ✓';
          var variantName = variant.title === 'Default Title' ? '' : ' (' + variant.title + ')';
          var msg = '<p class="dwo-toast__title">Added to cart: <strong>' + escapeHtml(data.title + variantName) +
            '</strong> × ' + quantity + '</p>';
          if (comboMode && offerActive()) {
            msg += '<p class="dwo-toast__offer">🎉 Your <strong>FREE Sesame Oil</strong> is included in this combo. Happy Diwali!</p>';
          } else if (res && offerActive()) {
            var offerHtml = offerMessage(res.offer);
            if (offerHtml) msg += '<p class="dwo-toast__offer">' + offerHtml + '</p>';
          }
          showToast(msg);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            addLabel.textContent = 'Add to cart';
            addBtn.disabled = false;
          }, 1500);
        })
        .catch(function (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
          addLabel.textContent = 'Add to cart';
          addBtn.disabled = false;
        })
        .then(function () { addBtn.classList.remove('is-loading'); });
    });

    update();
  }

  /* ---------------- boot ---------------- */

  function boot() {
    document.querySelectorAll('[data-dwo-card]').forEach(initCard);
    initHeroFireworks();
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-dwo-card]').forEach(initCard);
    document.querySelectorAll('[data-dwo-progress]').forEach(function (el) { el.__dwoBuilt = false; });
    initHeroFireworks();
    refresh();
  });

  C.refresh = refresh;
})();
